import axiosServices from 'utils/axios';
import { CreatePlayerDto, PlayerDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const createPlayer = async (player: CreatePlayerDto): Promise<PlayerDto> => {
    try {
        const res = await axiosServices.post<PlayerDto>(InsideFifaBackOfficeEndpoints.Players, player);

        return res.data;
    } catch (err) {
        throw err;
    }
};
